// extracted by mini-css-extract-plugin
export default {"vopros":"vopros_vopros__aGlsJ","voprosMainTitle":"vopros_voprosMainTitle__1reKS","voprosContainer":"vopros_voprosContainer__U9kHA","voprosParagraph":"vopros_voprosParagraph__Yy1gR"};